import { useState, useEffect } from 'react'

const useIsActive = (id: string, activeItemId: string): boolean => {
  const [isActive, setIsActive] = useState<boolean>(false)
  useEffect(() => {
    if (activeItemId === id) {
      setIsActive(true)
    } else {
      setIsActive(false)
    }
  }, [activeItemId, id])
  return isActive
}

export default useIsActive
